import { PortfolioProject } from '../components/sections/portfolio/SectionPortfolio';
import jsonProjects from '../data/projects.json'

export class ProjectRepository {

    getAllProjects(): PortfolioProject[] {
        return jsonProjects.projects.map((project): PortfolioProject => {
            return {
                name: project.name,
                description: project.description,
                bannerImgName: project.bannerImgName,
                thumbnailImageName: project.thumbnailImageName,
                youtubeId: project.youtubeId,
                responsibilities: project.responsibilities,
                links: project.links.map((link): [string, string] => {
                    return [link.name, link.link];
                })
            }
        });
    }
}